<template>
    <div  class="pv4 bg-white">
        <mq-layout mq="xs">
            <h2 class="ph3 ph4-ns">{{heading}}</h2>
        </mq-layout>

        <mq-layout mq="sm+">
            <div class="container">
                <div class="col-xs-12">
                    <h2>{{heading}}</h2>
                </div>
            </div>
        </mq-layout>
    </div>
</template>

<script>
export default {
    props: {
        heading: {
            type: String
        }
    }
};
</script>
